/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as LoginRouteImport } from './routes/login'
import { Route as PlaygroundRouteImport } from './routes/playground'
import { Route as PlaygroundHistoryRouteImport } from './routes/playground-history'
import { Route as ProfileRouteImport } from './routes/profile'
import { Route as ReferenceImagesHistoryRouteImport } from './routes/reference-images-history'
import { Route as ReferencePlaygroundRouteImport } from './routes/reference-playground'
import { Route as SettingsRouteImport } from './routes/settings'
import { Route as ToolsRouteImport } from './routes/tools'
import { Route as VideoGenerationRouteImport } from './routes/video-generation'
import { Route as VideoGenerationHistoryRouteImport } from './routes/video-generation-history'
import { Route as WorkflowHistoryRouteImport } from './routes/workflow-history'
import { Route as FolderFolderIdRouteImport } from './routes/folder.$folderId'
import { Route as FolderListRouteImport } from './routes/folder.list'
import { Route as FolderNewRouteImport } from './routes/folder.new'
import { Route as PlaygroundIndexRouteImport } from './routes/playground.index'
import { Route as PlaygroundBackgroundRouteImport } from './routes/playground.background'
import { Route as PlaygroundCharacterRouteImport } from './routes/playground.character'
import { Route as PlaygroundCharacterNanobananaRouteImport } from './routes/playground.character-nanobanana'
import { Route as PlaygroundCompositionRouteImport } from './routes/playground.composition'
import { Route as PlaygroundEnrichmentRouteImport } from './routes/playground.enrichment'
import { Route as PlaygroundFreeflowRouteImport } from './routes/playground.freeflow'
import { Route as PlaygroundInpaintRouteImport } from './routes/playground.inpaint'
import { Route as PlaygroundOutpaintRouteImport } from './routes/playground.outpaint'
import { Route as PlaygroundReferenceBuilderRouteImport } from './routes/playground.reference-builder'
import { Route as PlaygroundRemoveBackgroundRouteImport } from './routes/playground.remove-background'
import { Route as PlaygroundUpscaleRouteImport } from './routes/playground.upscale'
import { Route as PocIndexRouteImport } from './routes/poc.index'
import { Route as PocRecipeGeneratorRouteImport } from './routes/poc.recipe-generator'
import { Route as SettingsIndexRouteImport } from './routes/settings.index'
import { Route as SettingsChangelogRouteImport } from './routes/settings.changelog'
import { Route as SettingsCharacterOnboardingRouteImport } from './routes/settings.character-onboarding'
import { Route as SettingsCharactersRouteImport } from './routes/settings.characters'
import { Route as SettingsCostTrackingRouteImport } from './routes/settings.cost-tracking'
import { Route as SettingsInfrastructureRouteImport } from './routes/settings.infrastructure'
import { Route as SettingsUsersRouteImport } from './routes/settings.users'
import { Route as ToolsIndexRouteImport } from './routes/tools.index'
import { Route as ToolsCharacterSheetRouteImport } from './routes/tools.character-sheet'
import { Route as ToolsMaskRouteImport } from './routes/tools.mask'
import { Route as ToolsOutpaintMaskRouteImport } from './routes/tools.outpaint-mask'
import { Route as ToolsScaleReferenceRouteImport } from './routes/tools.scale-reference'
import { Route as ToolsSocialMediaPreviewRouteImport } from './routes/tools.social-media-preview'
import { Route as WorkflowWorkflowIdRouteImport } from './routes/workflow.$workflowId'
import { Route as PocRecipeGeneratorIndexRouteImport } from './routes/poc.recipe-generator.index'
import { Route as PocRecipeGeneratorRunIdRouteImport } from './routes/poc.recipe-generator.$runId'
import { Route as PocRecipeGeneratorHistoryRouteImport } from './routes/poc.recipe-generator.history'
import { Route as SettingsCharactersIndexRouteImport } from './routes/settings.characters.index'
import { Route as SettingsCharactersCharacterRouteImport } from './routes/settings.characters.$character'
import { Route as WorkflowWorkflowIdIndexRouteImport } from './routes/workflow.$workflowId.index'
import { Route as WorkflowWorkflowIdAssetsRouteImport } from './routes/workflow.$workflowId.assets'
import { Route as PocRecipeGeneratorRunIdIndexRouteImport } from './routes/poc.recipe-generator.$runId.index'
import { Route as PocRecipeGeneratorRunIdPreviewRouteImport } from './routes/poc.recipe-generator.$runId.preview'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const PlaygroundRoute = PlaygroundRouteImport.update({
  id: '/playground',
  path: '/playground',
  getParentRoute: () => rootRouteImport,
} as any)
const PlaygroundHistoryRoute = PlaygroundHistoryRouteImport.update({
  id: '/playground-history',
  path: '/playground-history',
  getParentRoute: () => rootRouteImport,
} as any)
const ProfileRoute = ProfileRouteImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => rootRouteImport,
} as any)
const ReferenceImagesHistoryRoute = ReferenceImagesHistoryRouteImport.update({
  id: '/reference-images-history',
  path: '/reference-images-history',
  getParentRoute: () => rootRouteImport,
} as any)
const ReferencePlaygroundRoute = ReferencePlaygroundRouteImport.update({
  id: '/reference-playground',
  path: '/reference-playground',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsRoute = SettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => rootRouteImport,
} as any)
const ToolsRoute = ToolsRouteImport.update({
  id: '/tools',
  path: '/tools',
  getParentRoute: () => rootRouteImport,
} as any)
const VideoGenerationRoute = VideoGenerationRouteImport.update({
  id: '/video-generation',
  path: '/video-generation',
  getParentRoute: () => rootRouteImport,
} as any)
const VideoGenerationHistoryRoute = VideoGenerationHistoryRouteImport.update({
  id: '/video-generation-history',
  path: '/video-generation-history',
  getParentRoute: () => rootRouteImport,
} as any)
const WorkflowHistoryRoute = WorkflowHistoryRouteImport.update({
  id: '/workflow-history',
  path: '/workflow-history',
  getParentRoute: () => rootRouteImport,
} as any)
const FolderFolderIdRoute = FolderFolderIdRouteImport.update({
  id: '/folder/$folderId',
  path: '/folder/$folderId',
  getParentRoute: () => rootRouteImport,
} as any)
const FolderListRoute = FolderListRouteImport.update({
  id: '/folder/list',
  path: '/folder/list',
  getParentRoute: () => rootRouteImport,
} as any)
const FolderNewRoute = FolderNewRouteImport.update({
  id: '/folder/new',
  path: '/folder/new',
  getParentRoute: () => rootRouteImport,
} as any)
const PlaygroundIndexRoute = PlaygroundIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => PlaygroundRoute,
} as any)
const PlaygroundBackgroundRoute = PlaygroundBackgroundRouteImport.update({
  id: '/background',
  path: '/background',
  getParentRoute: () => PlaygroundRoute,
} as any)
const PlaygroundCharacterRoute = PlaygroundCharacterRouteImport.update({
  id: '/character',
  path: '/character',
  getParentRoute: () => PlaygroundRoute,
} as any)
const PlaygroundCharacterNanobananaRoute =
  PlaygroundCharacterNanobananaRouteImport.update({
    id: '/character-nanobanana',
    path: '/character-nanobanana',
    getParentRoute: () => PlaygroundRoute,
  } as any)
const PlaygroundCompositionRoute = PlaygroundCompositionRouteImport.update({
  id: '/composition',
  path: '/composition',
  getParentRoute: () => PlaygroundRoute,
} as any)
const PlaygroundEnrichmentRoute = PlaygroundEnrichmentRouteImport.update({
  id: '/enrichment',
  path: '/enrichment',
  getParentRoute: () => PlaygroundRoute,
} as any)
const PlaygroundFreeflowRoute = PlaygroundFreeflowRouteImport.update({
  id: '/freeflow',
  path: '/freeflow',
  getParentRoute: () => PlaygroundRoute,
} as any)
const PlaygroundInpaintRoute = PlaygroundInpaintRouteImport.update({
  id: '/inpaint',
  path: '/inpaint',
  getParentRoute: () => PlaygroundRoute,
} as any)
const PlaygroundOutpaintRoute = PlaygroundOutpaintRouteImport.update({
  id: '/outpaint',
  path: '/outpaint',
  getParentRoute: () => PlaygroundRoute,
} as any)
const PlaygroundReferenceBuilderRoute =
  PlaygroundReferenceBuilderRouteImport.update({
    id: '/reference-builder',
    path: '/reference-builder',
    getParentRoute: () => PlaygroundRoute,
  } as any)
const PlaygroundRemoveBackgroundRoute =
  PlaygroundRemoveBackgroundRouteImport.update({
    id: '/remove-background',
    path: '/remove-background',
    getParentRoute: () => PlaygroundRoute,
  } as any)
const PlaygroundUpscaleRoute = PlaygroundUpscaleRouteImport.update({
  id: '/upscale',
  path: '/upscale',
  getParentRoute: () => PlaygroundRoute,
} as any)
const PocIndexRoute = PocIndexRouteImport.update({
  id: '/poc/',
  path: '/poc/',
  getParentRoute: () => rootRouteImport,
} as any)
const PocRecipeGeneratorRoute = PocRecipeGeneratorRouteImport.update({
  id: '/poc/recipe-generator',
  path: '/poc/recipe-generator',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsIndexRoute = SettingsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => SettingsRoute,
} as any)
const SettingsChangelogRoute = SettingsChangelogRouteImport.update({
  id: '/changelog',
  path: '/changelog',
  getParentRoute: () => SettingsRoute,
} as any)
const SettingsCharacterOnboardingRoute =
  SettingsCharacterOnboardingRouteImport.update({
    id: '/character-onboarding',
    path: '/character-onboarding',
    getParentRoute: () => SettingsRoute,
  } as any)
const SettingsCharactersRoute = SettingsCharactersRouteImport.update({
  id: '/characters',
  path: '/characters',
  getParentRoute: () => SettingsRoute,
} as any)
const SettingsCostTrackingRoute = SettingsCostTrackingRouteImport.update({
  id: '/cost-tracking',
  path: '/cost-tracking',
  getParentRoute: () => SettingsRoute,
} as any)
const SettingsInfrastructureRoute = SettingsInfrastructureRouteImport.update({
  id: '/infrastructure',
  path: '/infrastructure',
  getParentRoute: () => SettingsRoute,
} as any)
const SettingsUsersRoute = SettingsUsersRouteImport.update({
  id: '/users',
  path: '/users',
  getParentRoute: () => SettingsRoute,
} as any)
const ToolsIndexRoute = ToolsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => ToolsRoute,
} as any)
const ToolsCharacterSheetRoute = ToolsCharacterSheetRouteImport.update({
  id: '/character-sheet',
  path: '/character-sheet',
  getParentRoute: () => ToolsRoute,
} as any)
const ToolsMaskRoute = ToolsMaskRouteImport.update({
  id: '/mask',
  path: '/mask',
  getParentRoute: () => ToolsRoute,
} as any)
const ToolsOutpaintMaskRoute = ToolsOutpaintMaskRouteImport.update({
  id: '/outpaint-mask',
  path: '/outpaint-mask',
  getParentRoute: () => ToolsRoute,
} as any)
const ToolsScaleReferenceRoute = ToolsScaleReferenceRouteImport.update({
  id: '/scale-reference',
  path: '/scale-reference',
  getParentRoute: () => ToolsRoute,
} as any)
const ToolsSocialMediaPreviewRoute = ToolsSocialMediaPreviewRouteImport.update({
  id: '/social-media-preview',
  path: '/social-media-preview',
  getParentRoute: () => ToolsRoute,
} as any)
const WorkflowWorkflowIdRoute = WorkflowWorkflowIdRouteImport.update({
  id: '/workflow/$workflowId',
  path: '/workflow/$workflowId',
  getParentRoute: () => rootRouteImport,
} as any)
const PocRecipeGeneratorIndexRoute = PocRecipeGeneratorIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => PocRecipeGeneratorRoute,
} as any)
const PocRecipeGeneratorRunIdRoute = PocRecipeGeneratorRunIdRouteImport.update({
  id: '/$runId',
  path: '/$runId',
  getParentRoute: () => PocRecipeGeneratorRoute,
} as any)
const PocRecipeGeneratorHistoryRoute =
  PocRecipeGeneratorHistoryRouteImport.update({
    id: '/history',
    path: '/history',
    getParentRoute: () => PocRecipeGeneratorRoute,
  } as any)
const SettingsCharactersIndexRoute = SettingsCharactersIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => SettingsCharactersRoute,
} as any)
const SettingsCharactersCharacterRoute =
  SettingsCharactersCharacterRouteImport.update({
    id: '/$character',
    path: '/$character',
    getParentRoute: () => SettingsCharactersRoute,
  } as any)
const WorkflowWorkflowIdIndexRoute = WorkflowWorkflowIdIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => WorkflowWorkflowIdRoute,
} as any)
const WorkflowWorkflowIdAssetsRoute =
  WorkflowWorkflowIdAssetsRouteImport.update({
    id: '/assets',
    path: '/assets',
    getParentRoute: () => WorkflowWorkflowIdRoute,
  } as any)
const PocRecipeGeneratorRunIdIndexRoute =
  PocRecipeGeneratorRunIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => PocRecipeGeneratorRunIdRoute,
  } as any)
const PocRecipeGeneratorRunIdPreviewRoute =
  PocRecipeGeneratorRunIdPreviewRouteImport.update({
    id: '/preview',
    path: '/preview',
    getParentRoute: () => PocRecipeGeneratorRunIdRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/playground': typeof PlaygroundRouteWithChildren
  '/playground-history': typeof PlaygroundHistoryRoute
  '/profile': typeof ProfileRoute
  '/reference-images-history': typeof ReferenceImagesHistoryRoute
  '/reference-playground': typeof ReferencePlaygroundRoute
  '/settings': typeof SettingsRouteWithChildren
  '/tools': typeof ToolsRouteWithChildren
  '/video-generation': typeof VideoGenerationRoute
  '/video-generation-history': typeof VideoGenerationHistoryRoute
  '/workflow-history': typeof WorkflowHistoryRoute
  '/folder/$folderId': typeof FolderFolderIdRoute
  '/folder/list': typeof FolderListRoute
  '/folder/new': typeof FolderNewRoute
  '/playground/background': typeof PlaygroundBackgroundRoute
  '/playground/character': typeof PlaygroundCharacterRoute
  '/playground/character-nanobanana': typeof PlaygroundCharacterNanobananaRoute
  '/playground/composition': typeof PlaygroundCompositionRoute
  '/playground/enrichment': typeof PlaygroundEnrichmentRoute
  '/playground/freeflow': typeof PlaygroundFreeflowRoute
  '/playground/inpaint': typeof PlaygroundInpaintRoute
  '/playground/outpaint': typeof PlaygroundOutpaintRoute
  '/playground/reference-builder': typeof PlaygroundReferenceBuilderRoute
  '/playground/remove-background': typeof PlaygroundRemoveBackgroundRoute
  '/playground/upscale': typeof PlaygroundUpscaleRoute
  '/poc/recipe-generator': typeof PocRecipeGeneratorRouteWithChildren
  '/settings/changelog': typeof SettingsChangelogRoute
  '/settings/character-onboarding': typeof SettingsCharacterOnboardingRoute
  '/settings/characters': typeof SettingsCharactersRouteWithChildren
  '/settings/cost-tracking': typeof SettingsCostTrackingRoute
  '/settings/infrastructure': typeof SettingsInfrastructureRoute
  '/settings/users': typeof SettingsUsersRoute
  '/tools/character-sheet': typeof ToolsCharacterSheetRoute
  '/tools/mask': typeof ToolsMaskRoute
  '/tools/outpaint-mask': typeof ToolsOutpaintMaskRoute
  '/tools/scale-reference': typeof ToolsScaleReferenceRoute
  '/tools/social-media-preview': typeof ToolsSocialMediaPreviewRoute
  '/workflow/$workflowId': typeof WorkflowWorkflowIdRouteWithChildren
  '/playground/': typeof PlaygroundIndexRoute
  '/poc/': typeof PocIndexRoute
  '/settings/': typeof SettingsIndexRoute
  '/tools/': typeof ToolsIndexRoute
  '/poc/recipe-generator/$runId': typeof PocRecipeGeneratorRunIdRouteWithChildren
  '/poc/recipe-generator/history': typeof PocRecipeGeneratorHistoryRoute
  '/settings/characters/$character': typeof SettingsCharactersCharacterRoute
  '/workflow/$workflowId/assets': typeof WorkflowWorkflowIdAssetsRoute
  '/poc/recipe-generator/': typeof PocRecipeGeneratorIndexRoute
  '/settings/characters/': typeof SettingsCharactersIndexRoute
  '/workflow/$workflowId/': typeof WorkflowWorkflowIdIndexRoute
  '/poc/recipe-generator/$runId/preview': typeof PocRecipeGeneratorRunIdPreviewRoute
  '/poc/recipe-generator/$runId/': typeof PocRecipeGeneratorRunIdIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/playground-history': typeof PlaygroundHistoryRoute
  '/profile': typeof ProfileRoute
  '/reference-images-history': typeof ReferenceImagesHistoryRoute
  '/reference-playground': typeof ReferencePlaygroundRoute
  '/video-generation': typeof VideoGenerationRoute
  '/video-generation-history': typeof VideoGenerationHistoryRoute
  '/workflow-history': typeof WorkflowHistoryRoute
  '/folder/$folderId': typeof FolderFolderIdRoute
  '/folder/list': typeof FolderListRoute
  '/folder/new': typeof FolderNewRoute
  '/playground/background': typeof PlaygroundBackgroundRoute
  '/playground/character': typeof PlaygroundCharacterRoute
  '/playground/character-nanobanana': typeof PlaygroundCharacterNanobananaRoute
  '/playground/composition': typeof PlaygroundCompositionRoute
  '/playground/enrichment': typeof PlaygroundEnrichmentRoute
  '/playground/freeflow': typeof PlaygroundFreeflowRoute
  '/playground/inpaint': typeof PlaygroundInpaintRoute
  '/playground/outpaint': typeof PlaygroundOutpaintRoute
  '/playground/reference-builder': typeof PlaygroundReferenceBuilderRoute
  '/playground/remove-background': typeof PlaygroundRemoveBackgroundRoute
  '/playground/upscale': typeof PlaygroundUpscaleRoute
  '/settings/changelog': typeof SettingsChangelogRoute
  '/settings/character-onboarding': typeof SettingsCharacterOnboardingRoute
  '/settings/cost-tracking': typeof SettingsCostTrackingRoute
  '/settings/infrastructure': typeof SettingsInfrastructureRoute
  '/settings/users': typeof SettingsUsersRoute
  '/tools/character-sheet': typeof ToolsCharacterSheetRoute
  '/tools/mask': typeof ToolsMaskRoute
  '/tools/outpaint-mask': typeof ToolsOutpaintMaskRoute
  '/tools/scale-reference': typeof ToolsScaleReferenceRoute
  '/tools/social-media-preview': typeof ToolsSocialMediaPreviewRoute
  '/playground': typeof PlaygroundIndexRoute
  '/poc': typeof PocIndexRoute
  '/settings': typeof SettingsIndexRoute
  '/tools': typeof ToolsIndexRoute
  '/poc/recipe-generator/history': typeof PocRecipeGeneratorHistoryRoute
  '/settings/characters/$character': typeof SettingsCharactersCharacterRoute
  '/workflow/$workflowId/assets': typeof WorkflowWorkflowIdAssetsRoute
  '/poc/recipe-generator': typeof PocRecipeGeneratorIndexRoute
  '/settings/characters': typeof SettingsCharactersIndexRoute
  '/workflow/$workflowId': typeof WorkflowWorkflowIdIndexRoute
  '/poc/recipe-generator/$runId/preview': typeof PocRecipeGeneratorRunIdPreviewRoute
  '/poc/recipe-generator/$runId': typeof PocRecipeGeneratorRunIdIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/playground': typeof PlaygroundRouteWithChildren
  '/playground-history': typeof PlaygroundHistoryRoute
  '/profile': typeof ProfileRoute
  '/reference-images-history': typeof ReferenceImagesHistoryRoute
  '/reference-playground': typeof ReferencePlaygroundRoute
  '/settings': typeof SettingsRouteWithChildren
  '/tools': typeof ToolsRouteWithChildren
  '/video-generation': typeof VideoGenerationRoute
  '/video-generation-history': typeof VideoGenerationHistoryRoute
  '/workflow-history': typeof WorkflowHistoryRoute
  '/folder/$folderId': typeof FolderFolderIdRoute
  '/folder/list': typeof FolderListRoute
  '/folder/new': typeof FolderNewRoute
  '/playground/background': typeof PlaygroundBackgroundRoute
  '/playground/character': typeof PlaygroundCharacterRoute
  '/playground/character-nanobanana': typeof PlaygroundCharacterNanobananaRoute
  '/playground/composition': typeof PlaygroundCompositionRoute
  '/playground/enrichment': typeof PlaygroundEnrichmentRoute
  '/playground/freeflow': typeof PlaygroundFreeflowRoute
  '/playground/inpaint': typeof PlaygroundInpaintRoute
  '/playground/outpaint': typeof PlaygroundOutpaintRoute
  '/playground/reference-builder': typeof PlaygroundReferenceBuilderRoute
  '/playground/remove-background': typeof PlaygroundRemoveBackgroundRoute
  '/playground/upscale': typeof PlaygroundUpscaleRoute
  '/poc/recipe-generator': typeof PocRecipeGeneratorRouteWithChildren
  '/settings/changelog': typeof SettingsChangelogRoute
  '/settings/character-onboarding': typeof SettingsCharacterOnboardingRoute
  '/settings/characters': typeof SettingsCharactersRouteWithChildren
  '/settings/cost-tracking': typeof SettingsCostTrackingRoute
  '/settings/infrastructure': typeof SettingsInfrastructureRoute
  '/settings/users': typeof SettingsUsersRoute
  '/tools/character-sheet': typeof ToolsCharacterSheetRoute
  '/tools/mask': typeof ToolsMaskRoute
  '/tools/outpaint-mask': typeof ToolsOutpaintMaskRoute
  '/tools/scale-reference': typeof ToolsScaleReferenceRoute
  '/tools/social-media-preview': typeof ToolsSocialMediaPreviewRoute
  '/workflow/$workflowId': typeof WorkflowWorkflowIdRouteWithChildren
  '/playground/': typeof PlaygroundIndexRoute
  '/poc/': typeof PocIndexRoute
  '/settings/': typeof SettingsIndexRoute
  '/tools/': typeof ToolsIndexRoute
  '/poc/recipe-generator/$runId': typeof PocRecipeGeneratorRunIdRouteWithChildren
  '/poc/recipe-generator/history': typeof PocRecipeGeneratorHistoryRoute
  '/settings/characters/$character': typeof SettingsCharactersCharacterRoute
  '/workflow/$workflowId/assets': typeof WorkflowWorkflowIdAssetsRoute
  '/poc/recipe-generator/': typeof PocRecipeGeneratorIndexRoute
  '/settings/characters/': typeof SettingsCharactersIndexRoute
  '/workflow/$workflowId/': typeof WorkflowWorkflowIdIndexRoute
  '/poc/recipe-generator/$runId/preview': typeof PocRecipeGeneratorRunIdPreviewRoute
  '/poc/recipe-generator/$runId/': typeof PocRecipeGeneratorRunIdIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/login'
    | '/playground'
    | '/playground-history'
    | '/profile'
    | '/reference-images-history'
    | '/reference-playground'
    | '/settings'
    | '/tools'
    | '/video-generation'
    | '/video-generation-history'
    | '/workflow-history'
    | '/folder/$folderId'
    | '/folder/list'
    | '/folder/new'
    | '/playground/background'
    | '/playground/character'
    | '/playground/character-nanobanana'
    | '/playground/composition'
    | '/playground/enrichment'
    | '/playground/freeflow'
    | '/playground/inpaint'
    | '/playground/outpaint'
    | '/playground/reference-builder'
    | '/playground/remove-background'
    | '/playground/upscale'
    | '/poc/recipe-generator'
    | '/settings/changelog'
    | '/settings/character-onboarding'
    | '/settings/characters'
    | '/settings/cost-tracking'
    | '/settings/infrastructure'
    | '/settings/users'
    | '/tools/character-sheet'
    | '/tools/mask'
    | '/tools/outpaint-mask'
    | '/tools/scale-reference'
    | '/tools/social-media-preview'
    | '/workflow/$workflowId'
    | '/playground/'
    | '/poc/'
    | '/settings/'
    | '/tools/'
    | '/poc/recipe-generator/$runId'
    | '/poc/recipe-generator/history'
    | '/settings/characters/$character'
    | '/workflow/$workflowId/assets'
    | '/poc/recipe-generator/'
    | '/settings/characters/'
    | '/workflow/$workflowId/'
    | '/poc/recipe-generator/$runId/preview'
    | '/poc/recipe-generator/$runId/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/login'
    | '/playground-history'
    | '/profile'
    | '/reference-images-history'
    | '/reference-playground'
    | '/video-generation'
    | '/video-generation-history'
    | '/workflow-history'
    | '/folder/$folderId'
    | '/folder/list'
    | '/folder/new'
    | '/playground/background'
    | '/playground/character'
    | '/playground/character-nanobanana'
    | '/playground/composition'
    | '/playground/enrichment'
    | '/playground/freeflow'
    | '/playground/inpaint'
    | '/playground/outpaint'
    | '/playground/reference-builder'
    | '/playground/remove-background'
    | '/playground/upscale'
    | '/settings/changelog'
    | '/settings/character-onboarding'
    | '/settings/cost-tracking'
    | '/settings/infrastructure'
    | '/settings/users'
    | '/tools/character-sheet'
    | '/tools/mask'
    | '/tools/outpaint-mask'
    | '/tools/scale-reference'
    | '/tools/social-media-preview'
    | '/playground'
    | '/poc'
    | '/settings'
    | '/tools'
    | '/poc/recipe-generator/history'
    | '/settings/characters/$character'
    | '/workflow/$workflowId/assets'
    | '/poc/recipe-generator'
    | '/settings/characters'
    | '/workflow/$workflowId'
    | '/poc/recipe-generator/$runId/preview'
    | '/poc/recipe-generator/$runId'
  id:
    | '__root__'
    | '/'
    | '/login'
    | '/playground'
    | '/playground-history'
    | '/profile'
    | '/reference-images-history'
    | '/reference-playground'
    | '/settings'
    | '/tools'
    | '/video-generation'
    | '/video-generation-history'
    | '/workflow-history'
    | '/folder/$folderId'
    | '/folder/list'
    | '/folder/new'
    | '/playground/background'
    | '/playground/character'
    | '/playground/character-nanobanana'
    | '/playground/composition'
    | '/playground/enrichment'
    | '/playground/freeflow'
    | '/playground/inpaint'
    | '/playground/outpaint'
    | '/playground/reference-builder'
    | '/playground/remove-background'
    | '/playground/upscale'
    | '/poc/recipe-generator'
    | '/settings/changelog'
    | '/settings/character-onboarding'
    | '/settings/characters'
    | '/settings/cost-tracking'
    | '/settings/infrastructure'
    | '/settings/users'
    | '/tools/character-sheet'
    | '/tools/mask'
    | '/tools/outpaint-mask'
    | '/tools/scale-reference'
    | '/tools/social-media-preview'
    | '/workflow/$workflowId'
    | '/playground/'
    | '/poc/'
    | '/settings/'
    | '/tools/'
    | '/poc/recipe-generator/$runId'
    | '/poc/recipe-generator/history'
    | '/settings/characters/$character'
    | '/workflow/$workflowId/assets'
    | '/poc/recipe-generator/'
    | '/settings/characters/'
    | '/workflow/$workflowId/'
    | '/poc/recipe-generator/$runId/preview'
    | '/poc/recipe-generator/$runId/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  LoginRoute: typeof LoginRoute
  PlaygroundRoute: typeof PlaygroundRouteWithChildren
  PlaygroundHistoryRoute: typeof PlaygroundHistoryRoute
  ProfileRoute: typeof ProfileRoute
  ReferenceImagesHistoryRoute: typeof ReferenceImagesHistoryRoute
  ReferencePlaygroundRoute: typeof ReferencePlaygroundRoute
  SettingsRoute: typeof SettingsRouteWithChildren
  ToolsRoute: typeof ToolsRouteWithChildren
  VideoGenerationRoute: typeof VideoGenerationRoute
  VideoGenerationHistoryRoute: typeof VideoGenerationHistoryRoute
  WorkflowHistoryRoute: typeof WorkflowHistoryRoute
  FolderFolderIdRoute: typeof FolderFolderIdRoute
  FolderListRoute: typeof FolderListRoute
  FolderNewRoute: typeof FolderNewRoute
  PocRecipeGeneratorRoute: typeof PocRecipeGeneratorRouteWithChildren
  WorkflowWorkflowIdRoute: typeof WorkflowWorkflowIdRouteWithChildren
  PocIndexRoute: typeof PocIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/playground': {
      id: '/playground'
      path: '/playground'
      fullPath: '/playground'
      preLoaderRoute: typeof PlaygroundRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/playground-history': {
      id: '/playground-history'
      path: '/playground-history'
      fullPath: '/playground-history'
      preLoaderRoute: typeof PlaygroundHistoryRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/profile': {
      id: '/profile'
      path: '/profile'
      fullPath: '/profile'
      preLoaderRoute: typeof ProfileRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reference-images-history': {
      id: '/reference-images-history'
      path: '/reference-images-history'
      fullPath: '/reference-images-history'
      preLoaderRoute: typeof ReferenceImagesHistoryRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reference-playground': {
      id: '/reference-playground'
      path: '/reference-playground'
      fullPath: '/reference-playground'
      preLoaderRoute: typeof ReferencePlaygroundRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings': {
      id: '/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof SettingsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/tools': {
      id: '/tools'
      path: '/tools'
      fullPath: '/tools'
      preLoaderRoute: typeof ToolsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/video-generation': {
      id: '/video-generation'
      path: '/video-generation'
      fullPath: '/video-generation'
      preLoaderRoute: typeof VideoGenerationRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/video-generation-history': {
      id: '/video-generation-history'
      path: '/video-generation-history'
      fullPath: '/video-generation-history'
      preLoaderRoute: typeof VideoGenerationHistoryRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/workflow-history': {
      id: '/workflow-history'
      path: '/workflow-history'
      fullPath: '/workflow-history'
      preLoaderRoute: typeof WorkflowHistoryRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/folder/$folderId': {
      id: '/folder/$folderId'
      path: '/folder/$folderId'
      fullPath: '/folder/$folderId'
      preLoaderRoute: typeof FolderFolderIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/folder/list': {
      id: '/folder/list'
      path: '/folder/list'
      fullPath: '/folder/list'
      preLoaderRoute: typeof FolderListRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/folder/new': {
      id: '/folder/new'
      path: '/folder/new'
      fullPath: '/folder/new'
      preLoaderRoute: typeof FolderNewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/playground/': {
      id: '/playground/'
      path: '/'
      fullPath: '/playground/'
      preLoaderRoute: typeof PlaygroundIndexRouteImport
      parentRoute: typeof PlaygroundRoute
    }
    '/playground/background': {
      id: '/playground/background'
      path: '/background'
      fullPath: '/playground/background'
      preLoaderRoute: typeof PlaygroundBackgroundRouteImport
      parentRoute: typeof PlaygroundRoute
    }
    '/playground/character': {
      id: '/playground/character'
      path: '/character'
      fullPath: '/playground/character'
      preLoaderRoute: typeof PlaygroundCharacterRouteImport
      parentRoute: typeof PlaygroundRoute
    }
    '/playground/character-nanobanana': {
      id: '/playground/character-nanobanana'
      path: '/character-nanobanana'
      fullPath: '/playground/character-nanobanana'
      preLoaderRoute: typeof PlaygroundCharacterNanobananaRouteImport
      parentRoute: typeof PlaygroundRoute
    }
    '/playground/composition': {
      id: '/playground/composition'
      path: '/composition'
      fullPath: '/playground/composition'
      preLoaderRoute: typeof PlaygroundCompositionRouteImport
      parentRoute: typeof PlaygroundRoute
    }
    '/playground/enrichment': {
      id: '/playground/enrichment'
      path: '/enrichment'
      fullPath: '/playground/enrichment'
      preLoaderRoute: typeof PlaygroundEnrichmentRouteImport
      parentRoute: typeof PlaygroundRoute
    }
    '/playground/freeflow': {
      id: '/playground/freeflow'
      path: '/freeflow'
      fullPath: '/playground/freeflow'
      preLoaderRoute: typeof PlaygroundFreeflowRouteImport
      parentRoute: typeof PlaygroundRoute
    }
    '/playground/inpaint': {
      id: '/playground/inpaint'
      path: '/inpaint'
      fullPath: '/playground/inpaint'
      preLoaderRoute: typeof PlaygroundInpaintRouteImport
      parentRoute: typeof PlaygroundRoute
    }
    '/playground/outpaint': {
      id: '/playground/outpaint'
      path: '/outpaint'
      fullPath: '/playground/outpaint'
      preLoaderRoute: typeof PlaygroundOutpaintRouteImport
      parentRoute: typeof PlaygroundRoute
    }
    '/playground/reference-builder': {
      id: '/playground/reference-builder'
      path: '/reference-builder'
      fullPath: '/playground/reference-builder'
      preLoaderRoute: typeof PlaygroundReferenceBuilderRouteImport
      parentRoute: typeof PlaygroundRoute
    }
    '/playground/remove-background': {
      id: '/playground/remove-background'
      path: '/remove-background'
      fullPath: '/playground/remove-background'
      preLoaderRoute: typeof PlaygroundRemoveBackgroundRouteImport
      parentRoute: typeof PlaygroundRoute
    }
    '/playground/upscale': {
      id: '/playground/upscale'
      path: '/upscale'
      fullPath: '/playground/upscale'
      preLoaderRoute: typeof PlaygroundUpscaleRouteImport
      parentRoute: typeof PlaygroundRoute
    }
    '/poc/': {
      id: '/poc/'
      path: '/poc'
      fullPath: '/poc/'
      preLoaderRoute: typeof PocIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/poc/recipe-generator': {
      id: '/poc/recipe-generator'
      path: '/poc/recipe-generator'
      fullPath: '/poc/recipe-generator'
      preLoaderRoute: typeof PocRecipeGeneratorRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/': {
      id: '/settings/'
      path: '/'
      fullPath: '/settings/'
      preLoaderRoute: typeof SettingsIndexRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/settings/changelog': {
      id: '/settings/changelog'
      path: '/changelog'
      fullPath: '/settings/changelog'
      preLoaderRoute: typeof SettingsChangelogRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/settings/character-onboarding': {
      id: '/settings/character-onboarding'
      path: '/character-onboarding'
      fullPath: '/settings/character-onboarding'
      preLoaderRoute: typeof SettingsCharacterOnboardingRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/settings/characters': {
      id: '/settings/characters'
      path: '/characters'
      fullPath: '/settings/characters'
      preLoaderRoute: typeof SettingsCharactersRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/settings/cost-tracking': {
      id: '/settings/cost-tracking'
      path: '/cost-tracking'
      fullPath: '/settings/cost-tracking'
      preLoaderRoute: typeof SettingsCostTrackingRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/settings/infrastructure': {
      id: '/settings/infrastructure'
      path: '/infrastructure'
      fullPath: '/settings/infrastructure'
      preLoaderRoute: typeof SettingsInfrastructureRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/settings/users': {
      id: '/settings/users'
      path: '/users'
      fullPath: '/settings/users'
      preLoaderRoute: typeof SettingsUsersRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/tools/': {
      id: '/tools/'
      path: '/'
      fullPath: '/tools/'
      preLoaderRoute: typeof ToolsIndexRouteImport
      parentRoute: typeof ToolsRoute
    }
    '/tools/character-sheet': {
      id: '/tools/character-sheet'
      path: '/character-sheet'
      fullPath: '/tools/character-sheet'
      preLoaderRoute: typeof ToolsCharacterSheetRouteImport
      parentRoute: typeof ToolsRoute
    }
    '/tools/mask': {
      id: '/tools/mask'
      path: '/mask'
      fullPath: '/tools/mask'
      preLoaderRoute: typeof ToolsMaskRouteImport
      parentRoute: typeof ToolsRoute
    }
    '/tools/outpaint-mask': {
      id: '/tools/outpaint-mask'
      path: '/outpaint-mask'
      fullPath: '/tools/outpaint-mask'
      preLoaderRoute: typeof ToolsOutpaintMaskRouteImport
      parentRoute: typeof ToolsRoute
    }
    '/tools/scale-reference': {
      id: '/tools/scale-reference'
      path: '/scale-reference'
      fullPath: '/tools/scale-reference'
      preLoaderRoute: typeof ToolsScaleReferenceRouteImport
      parentRoute: typeof ToolsRoute
    }
    '/tools/social-media-preview': {
      id: '/tools/social-media-preview'
      path: '/social-media-preview'
      fullPath: '/tools/social-media-preview'
      preLoaderRoute: typeof ToolsSocialMediaPreviewRouteImport
      parentRoute: typeof ToolsRoute
    }
    '/workflow/$workflowId': {
      id: '/workflow/$workflowId'
      path: '/workflow/$workflowId'
      fullPath: '/workflow/$workflowId'
      preLoaderRoute: typeof WorkflowWorkflowIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/poc/recipe-generator/': {
      id: '/poc/recipe-generator/'
      path: '/'
      fullPath: '/poc/recipe-generator/'
      preLoaderRoute: typeof PocRecipeGeneratorIndexRouteImport
      parentRoute: typeof PocRecipeGeneratorRoute
    }
    '/poc/recipe-generator/$runId': {
      id: '/poc/recipe-generator/$runId'
      path: '/$runId'
      fullPath: '/poc/recipe-generator/$runId'
      preLoaderRoute: typeof PocRecipeGeneratorRunIdRouteImport
      parentRoute: typeof PocRecipeGeneratorRoute
    }
    '/poc/recipe-generator/history': {
      id: '/poc/recipe-generator/history'
      path: '/history'
      fullPath: '/poc/recipe-generator/history'
      preLoaderRoute: typeof PocRecipeGeneratorHistoryRouteImport
      parentRoute: typeof PocRecipeGeneratorRoute
    }
    '/settings/characters/': {
      id: '/settings/characters/'
      path: '/'
      fullPath: '/settings/characters/'
      preLoaderRoute: typeof SettingsCharactersIndexRouteImport
      parentRoute: typeof SettingsCharactersRoute
    }
    '/settings/characters/$character': {
      id: '/settings/characters/$character'
      path: '/$character'
      fullPath: '/settings/characters/$character'
      preLoaderRoute: typeof SettingsCharactersCharacterRouteImport
      parentRoute: typeof SettingsCharactersRoute
    }
    '/workflow/$workflowId/': {
      id: '/workflow/$workflowId/'
      path: '/'
      fullPath: '/workflow/$workflowId/'
      preLoaderRoute: typeof WorkflowWorkflowIdIndexRouteImport
      parentRoute: typeof WorkflowWorkflowIdRoute
    }
    '/workflow/$workflowId/assets': {
      id: '/workflow/$workflowId/assets'
      path: '/assets'
      fullPath: '/workflow/$workflowId/assets'
      preLoaderRoute: typeof WorkflowWorkflowIdAssetsRouteImport
      parentRoute: typeof WorkflowWorkflowIdRoute
    }
    '/poc/recipe-generator/$runId/': {
      id: '/poc/recipe-generator/$runId/'
      path: '/'
      fullPath: '/poc/recipe-generator/$runId/'
      preLoaderRoute: typeof PocRecipeGeneratorRunIdIndexRouteImport
      parentRoute: typeof PocRecipeGeneratorRunIdRoute
    }
    '/poc/recipe-generator/$runId/preview': {
      id: '/poc/recipe-generator/$runId/preview'
      path: '/preview'
      fullPath: '/poc/recipe-generator/$runId/preview'
      preLoaderRoute: typeof PocRecipeGeneratorRunIdPreviewRouteImport
      parentRoute: typeof PocRecipeGeneratorRunIdRoute
    }
  }
}

interface PlaygroundRouteChildren {
  PlaygroundBackgroundRoute: typeof PlaygroundBackgroundRoute
  PlaygroundCharacterRoute: typeof PlaygroundCharacterRoute
  PlaygroundCharacterNanobananaRoute: typeof PlaygroundCharacterNanobananaRoute
  PlaygroundCompositionRoute: typeof PlaygroundCompositionRoute
  PlaygroundEnrichmentRoute: typeof PlaygroundEnrichmentRoute
  PlaygroundFreeflowRoute: typeof PlaygroundFreeflowRoute
  PlaygroundInpaintRoute: typeof PlaygroundInpaintRoute
  PlaygroundOutpaintRoute: typeof PlaygroundOutpaintRoute
  PlaygroundReferenceBuilderRoute: typeof PlaygroundReferenceBuilderRoute
  PlaygroundRemoveBackgroundRoute: typeof PlaygroundRemoveBackgroundRoute
  PlaygroundUpscaleRoute: typeof PlaygroundUpscaleRoute
  PlaygroundIndexRoute: typeof PlaygroundIndexRoute
}

const PlaygroundRouteChildren: PlaygroundRouteChildren = {
  PlaygroundBackgroundRoute: PlaygroundBackgroundRoute,
  PlaygroundCharacterRoute: PlaygroundCharacterRoute,
  PlaygroundCharacterNanobananaRoute: PlaygroundCharacterNanobananaRoute,
  PlaygroundCompositionRoute: PlaygroundCompositionRoute,
  PlaygroundEnrichmentRoute: PlaygroundEnrichmentRoute,
  PlaygroundFreeflowRoute: PlaygroundFreeflowRoute,
  PlaygroundInpaintRoute: PlaygroundInpaintRoute,
  PlaygroundOutpaintRoute: PlaygroundOutpaintRoute,
  PlaygroundReferenceBuilderRoute: PlaygroundReferenceBuilderRoute,
  PlaygroundRemoveBackgroundRoute: PlaygroundRemoveBackgroundRoute,
  PlaygroundUpscaleRoute: PlaygroundUpscaleRoute,
  PlaygroundIndexRoute: PlaygroundIndexRoute,
}

const PlaygroundRouteWithChildren = PlaygroundRoute._addFileChildren(
  PlaygroundRouteChildren,
)

interface SettingsCharactersRouteChildren {
  SettingsCharactersCharacterRoute: typeof SettingsCharactersCharacterRoute
  SettingsCharactersIndexRoute: typeof SettingsCharactersIndexRoute
}

const SettingsCharactersRouteChildren: SettingsCharactersRouteChildren = {
  SettingsCharactersCharacterRoute: SettingsCharactersCharacterRoute,
  SettingsCharactersIndexRoute: SettingsCharactersIndexRoute,
}

const SettingsCharactersRouteWithChildren =
  SettingsCharactersRoute._addFileChildren(SettingsCharactersRouteChildren)

interface SettingsRouteChildren {
  SettingsChangelogRoute: typeof SettingsChangelogRoute
  SettingsCharacterOnboardingRoute: typeof SettingsCharacterOnboardingRoute
  SettingsCharactersRoute: typeof SettingsCharactersRouteWithChildren
  SettingsCostTrackingRoute: typeof SettingsCostTrackingRoute
  SettingsInfrastructureRoute: typeof SettingsInfrastructureRoute
  SettingsUsersRoute: typeof SettingsUsersRoute
  SettingsIndexRoute: typeof SettingsIndexRoute
}

const SettingsRouteChildren: SettingsRouteChildren = {
  SettingsChangelogRoute: SettingsChangelogRoute,
  SettingsCharacterOnboardingRoute: SettingsCharacterOnboardingRoute,
  SettingsCharactersRoute: SettingsCharactersRouteWithChildren,
  SettingsCostTrackingRoute: SettingsCostTrackingRoute,
  SettingsInfrastructureRoute: SettingsInfrastructureRoute,
  SettingsUsersRoute: SettingsUsersRoute,
  SettingsIndexRoute: SettingsIndexRoute,
}

const SettingsRouteWithChildren = SettingsRoute._addFileChildren(
  SettingsRouteChildren,
)

interface ToolsRouteChildren {
  ToolsCharacterSheetRoute: typeof ToolsCharacterSheetRoute
  ToolsMaskRoute: typeof ToolsMaskRoute
  ToolsOutpaintMaskRoute: typeof ToolsOutpaintMaskRoute
  ToolsScaleReferenceRoute: typeof ToolsScaleReferenceRoute
  ToolsSocialMediaPreviewRoute: typeof ToolsSocialMediaPreviewRoute
  ToolsIndexRoute: typeof ToolsIndexRoute
}

const ToolsRouteChildren: ToolsRouteChildren = {
  ToolsCharacterSheetRoute: ToolsCharacterSheetRoute,
  ToolsMaskRoute: ToolsMaskRoute,
  ToolsOutpaintMaskRoute: ToolsOutpaintMaskRoute,
  ToolsScaleReferenceRoute: ToolsScaleReferenceRoute,
  ToolsSocialMediaPreviewRoute: ToolsSocialMediaPreviewRoute,
  ToolsIndexRoute: ToolsIndexRoute,
}

const ToolsRouteWithChildren = ToolsRoute._addFileChildren(ToolsRouteChildren)

interface PocRecipeGeneratorRunIdRouteChildren {
  PocRecipeGeneratorRunIdPreviewRoute: typeof PocRecipeGeneratorRunIdPreviewRoute
  PocRecipeGeneratorRunIdIndexRoute: typeof PocRecipeGeneratorRunIdIndexRoute
}

const PocRecipeGeneratorRunIdRouteChildren: PocRecipeGeneratorRunIdRouteChildren =
  {
    PocRecipeGeneratorRunIdPreviewRoute: PocRecipeGeneratorRunIdPreviewRoute,
    PocRecipeGeneratorRunIdIndexRoute: PocRecipeGeneratorRunIdIndexRoute,
  }

const PocRecipeGeneratorRunIdRouteWithChildren =
  PocRecipeGeneratorRunIdRoute._addFileChildren(
    PocRecipeGeneratorRunIdRouteChildren,
  )

interface PocRecipeGeneratorRouteChildren {
  PocRecipeGeneratorRunIdRoute: typeof PocRecipeGeneratorRunIdRouteWithChildren
  PocRecipeGeneratorHistoryRoute: typeof PocRecipeGeneratorHistoryRoute
  PocRecipeGeneratorIndexRoute: typeof PocRecipeGeneratorIndexRoute
}

const PocRecipeGeneratorRouteChildren: PocRecipeGeneratorRouteChildren = {
  PocRecipeGeneratorRunIdRoute: PocRecipeGeneratorRunIdRouteWithChildren,
  PocRecipeGeneratorHistoryRoute: PocRecipeGeneratorHistoryRoute,
  PocRecipeGeneratorIndexRoute: PocRecipeGeneratorIndexRoute,
}

const PocRecipeGeneratorRouteWithChildren =
  PocRecipeGeneratorRoute._addFileChildren(PocRecipeGeneratorRouteChildren)

interface WorkflowWorkflowIdRouteChildren {
  WorkflowWorkflowIdAssetsRoute: typeof WorkflowWorkflowIdAssetsRoute
  WorkflowWorkflowIdIndexRoute: typeof WorkflowWorkflowIdIndexRoute
}

const WorkflowWorkflowIdRouteChildren: WorkflowWorkflowIdRouteChildren = {
  WorkflowWorkflowIdAssetsRoute: WorkflowWorkflowIdAssetsRoute,
  WorkflowWorkflowIdIndexRoute: WorkflowWorkflowIdIndexRoute,
}

const WorkflowWorkflowIdRouteWithChildren =
  WorkflowWorkflowIdRoute._addFileChildren(WorkflowWorkflowIdRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  LoginRoute: LoginRoute,
  PlaygroundRoute: PlaygroundRouteWithChildren,
  PlaygroundHistoryRoute: PlaygroundHistoryRoute,
  ProfileRoute: ProfileRoute,
  ReferenceImagesHistoryRoute: ReferenceImagesHistoryRoute,
  ReferencePlaygroundRoute: ReferencePlaygroundRoute,
  SettingsRoute: SettingsRouteWithChildren,
  ToolsRoute: ToolsRouteWithChildren,
  VideoGenerationRoute: VideoGenerationRoute,
  VideoGenerationHistoryRoute: VideoGenerationHistoryRoute,
  WorkflowHistoryRoute: WorkflowHistoryRoute,
  FolderFolderIdRoute: FolderFolderIdRoute,
  FolderListRoute: FolderListRoute,
  FolderNewRoute: FolderNewRoute,
  PocRecipeGeneratorRoute: PocRecipeGeneratorRouteWithChildren,
  WorkflowWorkflowIdRoute: WorkflowWorkflowIdRouteWithChildren,
  PocIndexRoute: PocIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
